@if (floating()) {
  <!-- UI_Version_2: name, description, then category and actions -->
  <div
    data-request-card-new-design
    class="flex h-full flex-col justify-between gap-lg whitespace-normal rounded-xl border border-neutral-200 bg-white p-lg transition-shadow hover:shadow-sm">
    <!-- Name and description each keep two lines of space, so every card has the same height.
         whitespace-normal: the table around the grid sets nowrap, which would stop the name wrapping. -->
    <div class="flex min-w-0 flex-col gap-x-sm">
      <h6
        data-request-card-name
        class="line-clamp-2 h-10 wrap-break-word text-sm leading-5 font-semibold text-neutral-900"
        [attr.title]="request().name">
        {{ request().name }}
      </h6>
      <p
        data-request-card-description
        class="line-clamp-2 h-8 wrap-break-word text-xs leading-4 text-neutral-500"
        [attr.title]="request().description || null">
        {{ request().description }}
      </p>
    </div>

    <div class="flex items-center justify-between gap-md">
      <span
        data-request-category
        class="flex min-w-0 items-center gap-sm text-xs text-neutral-600">
        <span
          class="size-1.5 shrink-0 rounded-full"
          [style.background-color]="categoryColor()"></span>
        <span class="truncate">{{ request().category.name }}</span>
      </span>
      <lib-request-actions [request]="request()" />
    </div>
  </div>
} @else {
  <div
    class="flex flex-col justify-between gap-lg p-lg bg-white border border-neutral-200 rounded-lg h-full"
    [class.border-s-4]="!!categoryBorderColor()"
    [style.border-inline-start-color]="categoryBorderColor()">
    <div class="flex flex-col gap-md">
      <!---------------  hide request icon for now ------------------>
      @if (!isInsightCardsNewDesign()) {
        <img
          class="rounded-sm size-8"
          alt="request-icon"
          width="32"
          height="32"
          [src]="
            request().icon ? request().icon.url : 'assets/images/Rectangle.png'
          " />
      }

      <div class="flex flex-col gap-md">
        <h6 class="text-sm font-semibold text-neutral-900 request-card-header">
          {{ request().name }}
        </h6>

        @let color = request().category.color;

        <lib-badge
          [badgeClass]="`px-sm text-sm font-medium text-neutral-700 border-none bg-neutral-100`"
          [color]="isCardRedesignedEnabled() ? (color ?? null) : null"
          [label]="request().category.name" />
      </div>
    </div>

    <!-- Card Actions -->
    <div class="flex justify-between border-t border-neutral-200 pt-lg">
      <a
        id="detail"
        [routerLink]="navigationPath()"
        (click)="savePreviousParams()"
        class="flex items-center bg-neutral-100 p-sm border-none rounded-md cursor-pointer"
        libPermissions
        [featurePermissions]="[appPermissions.workflow.view]"
        [userPermissions]="request().permissions">
        <lib-view-icon [iconClass]="'size-5 text-neutral-700'" />
      </a>

      @if (request().is_triggable) {
        <button
          id="trigger"
          type="button"
          (click)="triggerRequest(request().id)"
          libPermissions
          [featurePermissions]="[appPermissions.workflow.trigger]"
          [userPermissions]="request().permissions"
          class="flex items-center bg-primary-50 p-sm border-none rounded-md cursor-pointer">
          <lib-arrow-left-icon
            [iconClass]="'size-5 text-primary-500 rotate-180'" />
        </button>
      }
    </div>
  </div>
}
